import "@/App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import QuizSection from "./components/QuizSection";
import About from "./components/About";
import Process from "./components/Process";
import Services from "./components/Services";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App" data-testid="app-container">
      <Navbar />
      <Hero />
      <QuizSection />
      <About />
      <Process />
      <Services />
      <Testimonials />
      <Footer />
    </div>
  );
}

export default App;
